<template>
  <div class="main-div mb-3" style="">
    <div class="my-3">
      <p class="text-start">工單資訊</p>
      <commonTable :fields="workFields" :items="workItems">
        <template #cell(work_qty)="data">{{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}</template>
        <template #cell(standard_total_weight)="data">{{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}</template>
      </commonTable>
    </div>

    <div class="mb-3">
      <p class="text-start">打頭生產資訊</p>
      <commonTable :fields="produceFields" :items="produceItems">
        <template #cell(standard_total_weight)="data">{{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}</template>
        <template #cell(material_total_weight)="data">{{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}</template>
        <template #cell(unit_weight)="data">{{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}</template>
      </commonTable>
    </div>

    <div class="mb-3">
      <p class="text-start">損耗率</p>
      <commonTable :fields="attritionRateFields" :items="attritionRateItems">
        <template #thead-top="">
          <tr>
            <th rowspan="2" style="font-size: 16px; min-width: 60px">製程</th>
            <th rowspan="2" style="font-size: 16px; min-width: 115px">
              生產前總重(KG)
            </th>
            <th rowspan="2" style="font-size: 16px; min-width: 100px">
              生產總重(KG)
            </th>
            <th colspan="2" style="height: auto; font-size: 16px">損耗率(%)</th>
          </tr>
          <tr>
            <th style="height: auto; font-size: 16px; border-left: none">
              實際
            </th>
            <th style="height: auto; font-size: 16px">標準</th>
          </tr>
        </template>
        <template #cell(pre_total_weight)="data">{{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}</template>
        <template #cell(total_weight)="data">{{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}</template>
        <template #cell(attrition_rate_act)="data">
          <div
            :style="{
              color:
                data.item.attrition_rate_standard < data.value ? '#c10000' : '',
            }"
          >
            {{ data.value }}
          </div>
        </template>
      </commonTable>
    </div>

    <div class="mb-3">
      <p class="text-start">線材使用資訊</p>
      <commonTable
        :fields="wireFields"
        :items="wireItems"
        :extraItems="wireExtraItems"
      >
        <template #cell(item)="data">{{ data.index + 1 }}</template>
        <template #cell(consumption)="data">{{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}</template>
      </commonTable>
    </div>

    <div class="mb-3">
      <p class="text-start">使用模具資訊</p>
      <commonTable :fields="moldFields" :items="moldItems">
        <template #cell(used_life)="data">{{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}</template>
        <template #cell(standard_life)="data">{{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}</template>
      </commonTable>
    </div>

    <div class="mb-3">
      <p class="text-start">使用牙板資訊</p>
      <commonTable :fields="threadFields" :items="threadItems">
        <template #cell(used_life)="data">{{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}</template>
        <template #cell(standard_life)="data">{{
          isNaN(Number(data.value))
            ? data.value
            : Number(data.value).toLocaleString("en-US")
        }}</template>
      </commonTable>
    </div>

    <div class="mb-3">
      <p class="text-start">總生產時間</p>
      <commonTable :fields="produceTimeFields" :items="produceTimeItems" />
    </div>

    <div class="mb-3">
      <p class="text-start">表面處理資訊</p>
      <commonTable
        :fields="surfaceTreatmentFields"
        :items="surfaceTreatmentItems"
      />
    </div>

    <div class="mb-3">
      <p class="text-start">入庫資訊</p>
      <commonTable :fields="warehousingFields" :items="warehousingItems" />
    </div>

    <div class="mb-3">
      <p class="text-start mb-3">檢驗數值</p>

      <ul class="nav">
        <li
          class="li-tab inspection-head-tab"
          :class="{ 'inspection-head-tab-active': inspectTabIndex == 0 }"
          @click="inspectTabIndex = 0"
        >
          打頭
        </li>
        <li
          class="li-tab inspection-thread-tab"
          :class="{
            'inspection-thread-tab-active': inspectTabIndex == 1,
            'd-none': totalInspectionData.length < 2,
          }"
          @click="inspectTabIndex = 1"
        >
          輾牙
        </li>
      </ul>
      <div class="mt-3">
        <inspectionList :inspectionData="inspValue"></inspectionList>
      </div>
    </div>

    <div>
      <p class="text-start mb-3">熱處理運行數值</p>
      <whdHeatWorkData :htWorkData="htWorkData"></whdHeatWorkData>
    </div>

    <div class="mb-3">
      <p class="text-start mb-3">品管檢驗數值</p>
      <div class="mt-3">
        <qcInspectionList :inspectionData="qcInspValue"></qcInspectionList>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import commonTable from "./commonTable.vue";
import inspectionList from "@/components/inspectionList.vue";
import qcInspectionList from "@/components/qcInspectionList.vue";
import whdHeatWorkData from "@/components/workOrderHistoryList/whdHeatWorkData.vue";
import { computed, inject, provide, watch } from "@vue/runtime-core";
import { useStore } from "vuex";

export default {
  components: {
    commonTable,
    inspectionList,
    qcInspectionList,
    whdHeatWorkData,
  },
  setup() {
    const store = useStore();
    const path = inject("path");
    const wip_lot = inject("wip_lot");
    const listData = inject("listData");

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    //工單資訊
    const workFields = [
      {
        key: "code",
        label: "工單編號",
        thStyle: {
          "min-width": "90px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "productCode",
        label: "料號",
        thStyle: {
          "min-width": "190px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "control_card",
        label: "管制卡號",
        thStyle: {
          "min-width": "190px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "product_chinese_name",
        label: "料名",
        thStyle: {
          "min-width": "300px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "mould_code",
        label: "模具編號",
        thStyle: {
          "min-width": "160px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "work_qty",
        label: "派工支數",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "standard_total_weight",
        label: "生產總重(KG)",
        thStyle: {
          "min-width": "110px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const workItems = ref([]);

    //生產資訊
    const produceFields = [
      {
        key: "item_title",
        label: ["項目", "狀態"],
        segmentation: {
          sup: {},
          sub: {},
        },
        thStyle: {
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "unit_weight",
        label: "單支重(G)",
        thStyle: {
          "min-width": "105px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "standard_total_weight",
        label: "生產總重(KG)",
        thStyle: {
          "min-width": "125px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "material_total_weight",
        label: "原料使用總重(KG)",
        thStyle: {
          "min-width": "145px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const produceItems = ref([]);

    //損耗率
    const attritionRateFields = [
      {
        key: "process",
        label: "製程",
        thStyle: {
          "min-width": "95px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "pre_total_weight",
        label: "生產前總重(KG)",
        thStyle: {
          "min-width": "160px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "total_weight",
        label: "生產總重(KG)",
        thStyle: {
          "min-width": "140px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "attrition_rate_act",
        label: "實際",
        thStyle: {
          "min-width": "90px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "attrition_rate_standard",
        label: "標準",
        thStyle: {
          "min-width": "90px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const attritionRateItems = ref([]);

    //線材使用資訊
    const wireFields = [
      {
        key: "item",
        label: "項次",
        thStyle: {
          "min-width": "60px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "code",
        label: "線材品號",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "chinese_name",
        label: "線材品名",
        thStyle: {
          "min-width": "200px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "scroll_no",
        label: "線材捲號",
        thStyle: {
          "min-width": "175px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "furnaceCode",
        label: "爐號",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "consumption",
        label: "耗用量(KG)",
        thStyle: {
          "min-width": "95px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const wireItems = ref([]);
    const wireExtraItems = ref(["總計", ""]);

    //使用模具資訊
    const moldFields = [
      {
        key: "code",
        label: "零件編號",
        thStyle: {
          "min-width": "65px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "seriesNo",
        label: "零件序號",
        thStyle: {
          "min-width": "65px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "name",
        label: "零件名稱",
        thStyle: {
          "min-width": "65px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "used_life",
        label: "累積使用壽命",
        thStyle: {
          "min-width": "105px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "standard_life",
        label: "標準壽命",
        thStyle: {
          "min-width": "65px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const moldItems = ref([]);

    //使用牙板資訊
    const threadFields = [
      {
        key: "code",
        label: "牙板編號",
        thStyle: {
          "min-width": "65px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "seriesNo",
        label: "牙板序號",
        thStyle: {
          "min-width": "65px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "name",
        label: "牙板名稱",
        thStyle: {
          "min-width": "65px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "used_life",
        label: "累積使用壽命",
        thStyle: {
          "min-width": "105px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "standard_life",
        label: "標準壽命",
        thStyle: {
          "min-width": "65px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const threadItems = ref([]);

    //總生產時間
    const produceTimeFields = [
      {
        key: "code",
        label: "製程",

        thStyle: {
          "min-width": "70px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "deviceName",
        label: "機台編號",
        thStyle: {
          "min-width": "70px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "開始時間",
        thStyle: {
          "min-width": "170px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "結束時間",
        thStyle: {
          "min-width": "170px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "totalTime",
        label: "生產時間",
        thStyle: {
          "min-width": "160px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const produceTimeItems = ref([]);

    //表面處理資訊
    const surfaceTreatmentFields = [
      {
        key: "plating",
        label: "鍍別資訊",

        thStyle: {
          "min-width": "70px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "manufacturer",
        label: "委外廠商",
        thStyle: {
          "min-width": "70px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "startTime",
        label: "出廠日期",
        thStyle: {
          "min-width": "170px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "endTime",
        label: "返廠日期",
        thStyle: {
          "min-width": "170px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const surfaceTreatmentItems = ref([]);

    //入庫資訊
    const warehousingFields = [
      {
        key: "weight",
        label: "入庫重量",

        thStyle: {
          "min-width": "70px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "area",
        label: "儲區",
        thStyle: {
          "min-width": "70px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "spaces",
        label: "儲位",
        thStyle: {
          "min-width": "170px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "date",
        label: "入庫日期",
        thStyle: {
          "min-width": "170px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const warehousingItems = ref([]);

    //檢驗項目
    const inspectTabIndex = ref(null);
    const totalInspectionData = ref([]);
    const inspValue = ref({
      self: [],
      last: [],
      first: [],
      leaderNames: { first: null, self: null, last: null },
    });
    // watch tab 點擊改變
    watch(
      totalInspectionData,
      () => {
        inspectTabIndex.value = 0;
      },
      { deep: true }
    );
    watch(
      inspectTabIndex,
      (newValue) => {
        if (totalInspectionData.value.length == 0) {
          return;
        }
        inspValue.value = totalInspectionData.value[newValue]["data"];
      },
      { deep: true }
    );

    //熱處理
    const htWorkData = ref([]);

    //檢驗項目
    // const qcInspectTabIndex = ref(null);
    // const qcInspectionData = ref([]);
    const qcInspValue = ref({
      heat: [],
      surface: [],
      mechanical: [],
    });
    // watch tab 點擊改變
    // watch(
    //   qcInspectionData,
    //   () => {
    //     inspectTabIndex.value = 0;
    //   },
    //   { deep: true }
    // );
    // watch(
    //   qcInspectTabIndex,
    //   (newValue) => {
    //     if (qcInspectionData.value.length == 0) {
    //       return;
    //     }
    //     qcInspValue.value = qcInspectionData.value[newValue]["data"];
    //   },
    //   { deep: true }
    // );

    const queryWorkHistory = () => {
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "workorderhistory";
      params["methods"] = "POST";
      params["whichFunction"] = "QueryWorkId";
      params["wip_lot"] = wip_lot.value;
      params["singleWorkIdQuery"] = true;
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          console.log(result.QueryTableData);
          workItems.value = result.QueryTableData[0].work_code_information;
          produceItems.value =
            result.QueryTableData[0].heading_produce_information;
          attritionRateItems.value =
            result.QueryTableData[0].produce_information;
          wireExtraItems.value.splice(
            1,
            1,
            result.QueryTableData[0].wire_information.pop().consumption
          );
          wireItems.value = result.QueryTableData[0].wire_information;
          moldItems.value = result.QueryTableData[0].use_mould;
          threadItems.value = result.QueryTableData[0].use_thread;
          produceTimeItems.value = result.QueryTableData[0].total_work_time;
          totalInspectionData.value =
            result.QueryTableData[0].total_inspection_data;
          surfaceTreatmentItems.value =
            result.QueryTableData[0].surface_treatment;
          warehousingItems.value = result.QueryTableData[0].warehousing_info;
          htWorkData.value = result.QueryTableData[0].ht_work_data;
          qcInspValue.value = result.QueryTableData[0].qcInspValue;
          listData.value = {
            // batchFields: batchFields,
            // ingotFields: ingotFields,
            // castingFields: castingFields,
            // castingDetailFields: castingDetailFields,
            // eagerlyFields: eagerlyFields,
            // quenchingWaterFields: quenchingWaterFields,
            // useMoldFields: useMoldFields,
            // stoveFields: stoveFields,
            // batchItems: batchItems.value,
            // ingotItems: ingotItems.value,
            // forgeRecord: forgeRecord.value,
            // castingItems: castingItems.value,
            // useMoldItems: useMoldItems.value,
            // eagerlyItems: eagerlyItems.value,
            // quenchingWaterItems: quenchingWaterItems.value,
            // stoveTabData: stoveTabData.value,
            // forgeRecordSelectIndex: computed(() => pillsIndex.value),
          };
        } else {
          workItems.value = [];
          produceItems.value = [];
          attritionRateItems.value = [];
          wireItems.value = [];
          wireExtraItems.value = ["總計", ""];
          moldItems.value = [];
          threadItems.value = [];
          produceTimeItems.value = [];
          totalInspectionData.value = [];
          surfaceTreatmentItems.value = [];
          warehousingItems.value = [];
          htWorkData.value = [];
          qcInspValue.value = {
            heat: [],
            surface: [],
            mechanical: [],
          };
          listData.value = {};
        }
        methods.triggerLoadingBar();
      });
    };

    queryWorkHistory();

    // provide("commonMethods", commonMethods);

    return {
      workFields,
      workItems,
      produceFields,
      produceItems,
      attritionRateFields,
      attritionRateItems,
      wireFields,
      wireItems,
      wireExtraItems,
      moldFields,
      moldItems,
      threadFields,
      threadItems,
      produceTimeFields,
      produceTimeItems,
      surfaceTreatmentFields,
      surfaceTreatmentItems,
      warehousingFields,
      warehousingItems,
      inspectTabIndex,
      totalInspectionData,
      inspValue,
      htWorkData,
      // qcInspectTabIndex,
      // qcInspectionData,
      qcInspValue,
    };
  },
};
</script>

<style scoped>
p {
  margin: 0px;
}

.main-div {
  background-color: #f2f2f2;
}

.li-tab {
  width: 140px;
  margin-right: 0.2rem;
  padding: 0.5rem 1rem 0px;
  background-color: transparent;
  font-size: 1rem;
  font-family: dfyuanstd-w5, dfyuanstd-w3;
  cursor: pointer;
}

.inspection-head-tab {
  color: #427ace;
  border-bottom: 0.6rem solid #427ace;
}

.inspection-head-tab-active {
  color: #fff;
  background-color: #427ace;
  border-radius: 0.63rem 0.63rem 0 0;
}

.inspection-thread-tab {
  color: #009245;
  border-bottom: 0.6rem solid #009245;
}

.inspection-thread-tab-active {
  color: #fff;
  background-color: #009245;
  border-radius: 0.63rem 0.63rem 0 0;
}

.inspection-tab-display-none {
  display: none;
}
</style>
